import { GlobalService } from './../../services/global.service';
import { locale } from "devextreme/localization";
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from './../../services/auth.service';
import { DialogService } from '../../services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import i18n_it from "../../../assets/i18n/i18n_it.json";
import i18n_en from "../../../assets/i18n/i18n_en.json";
import i18n_fr from "../../../assets/i18n/i18n_fr.json";
import { LoginResult } from '../../models/loginResult.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { MynamirialbindingComponent } from './mynamirialbinding/mynamirialbinding.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { url } from 'inspector';

const LOCAL_STORAGE_CREDENTIAL: string = "fatturexlsCredential";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {

  loginForm: UntypedFormGroup;
  submitted = false;
  returnUrl: string;
  iFrameURL: SafeResourceUrl;
  displayiFrame = false;
  mynamirialhiddenecheck=false;  
  buyLicence: string = null;
  countriesArray : Array<any>=[{ code: 'fr', name: 'Francese',url:'../../../../../assets/img/icons/flags/fr.svg' }, { code: 'gb', name: 'English',url:'../../../../../assets/img/icons/flags/gb.svg' }];
  selectedCountryCode = 'fr';
  countryCodes = ['fr', 'gb'];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private authenticationService: AuthService,
    public sanitizer: DomSanitizer,
    
    private dialog: MatDialog
  ) {

    //Se è stato richiesto l'acquisto direttamente dallo shop, rimando alla pagina di acquisto con la login effettuata
    this.route.queryParams
      .subscribe(params => {
        if (params != null) {
          if (params.buyLicence != null && params.buyLicence == "true") {
            this.buyLicence = "true";
          }

           // Gestione uffici login automatica
           if (params.mytoken != null && params.mytoken != "") {                     
            // Fisso ambiente ELMAS tanto verrà unificato        
            this.authenticationService.setCurrentToken(params.mytoken);                
            // Nella defaultcomponents effettua il redirect su lista documenti
            this.authenticationService.setGestioneUfficiFlag("1");                        
          }      
          
          if (params.mynamirialtrusted != null ) {                     
            this.onOpeniFrame();
          }          
        }
      });

    // Se l'utente è già connesso faccio il redirect alla Home
    if (this.authenticationService.tokenAvailable()) {
      this.router.navigate(['/dashboard'], { queryParams: { buyLicence: this.buyLicence } })
    }

    // Se l'utente è già connesso con MyNamirial verifico validità token
    if (this.authenticationService.tokenMyNamirialAvailable()) {      
      this.mynamirialhiddenecheck = true;      
      //this.onOpeniFrame();
      
    }       

  }

  ngOnInit() {
        
    
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      remember: ['']
    });

    this.selectedCountryCode = GlobalService.getSelectedLanguage() == "en" ? "gb" : GlobalService.getSelectedLanguage();

    // Prendo il return url dai route parameteres o il default '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
    //Ricordami
    this.reloadCredentialIfExists();
  }

  /**
   * Cambio lingua
   * @param value
   */
  changeSelectedCountryCode(value: string): void {

    this.selectedCountryCode = value;
    this.initializeLanguage(value);

    this.reloadComponent();
  }

  /**
   * Ricarico i dati
   **/
  reloadComponent() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this.router.url]);
  }


  /**
   * Se le credenziali risultano memorizzate nel local storage allora le recupera e popola i controlli per la login
   */
  reloadCredentialIfExists() {



    var credentialEncoded = localStorage.getItem(LOCAL_STORAGE_CREDENTIAL);
    if (credentialEncoded != null) {
      var credentialDecoded = JSON.parse(atob(credentialEncoded));
      this.loginForm.patchValue({ email: credentialDecoded["email"], password: credentialDecoded["password"], remember: true });
    }
  }

  /**
   * Per accedere ai campi del form facilmente
   */
  get f() {
    return this.loginForm.controls;
  }

  /**
   * Al click del pulsante "Accedi" invio le credenziali
   * per effettuare il login all'utente
   */
  onSubmit(email: string = "", password: string = "", autologin: boolean = false) {

    if (!this.displayiFrame) {
      this.submitted = true;
      if (autologin == true) {
        this.authenticationService.login(email, password)
          .then((res: LoginResult) => {
            this.authenticationService.setCurrentToken(res.Token);            
            this.authenticationService.loggedIn.next(true);
            this.router.navigate(['/'], { queryParams: { buyLicence: this.buyLicence } });
          })
          .catch((err) => {
            this.authenticationService.loggedIn.next(false);
            DialogService.Error(err.message);
          });

      }
      // Se il form non è valido mi fermo
      if (this.loginForm.invalid) {
        return;
      }

      //Se richiesto, memorizza le credenziali nel localStorage
      if (this.f.remember.value == true) {
        var credential = { email: this.f.email.value, password: this.f.password.value };
        var credentialEncoded = btoa(JSON.stringify(credential));
        localStorage.setItem(LOCAL_STORAGE_CREDENTIAL, credentialEncoded);
      }
      else
        localStorage.removeItem(LOCAL_STORAGE_CREDENTIAL);

      this.authenticationService.login(this.f.email.value, this.f.password.value)
        .then((res: LoginResult) => {
          this.initializeLanguage(this.selectedCountryCode);
          this.authenticationService.setCurrentToken(res.Token);          
          this.authenticationService.loggedIn.next(true);
          this.router.navigate(['/'], { queryParams: { buyLicence: this.buyLicence } });
        }).then(() => {
        })
        .catch((err) => {
          this.authenticationService.loggedIn.next(false);
          if (err.message.substring(0, 6) === '@@Info') {
            DialogService.Info(err.message.substring(7));
          }
          else {
            DialogService.Error(err.message);
          }

        })
    };
  }

  
  initializeLanguage(value) {
    let selectedI18N: string;

    if (value == "it") {
      selectedI18N = "i18n_it";
    } else if (value == "fr") {
      selectedI18N = "i18n_fr";
    } else {
      selectedI18N = "i18n_en";
    }

    GlobalService.setSelectedLanguage(value == 'gb' ? 'en' : value);
    GlobalService.setI18N(selectedI18N);

    if (value == "it") {
      this.translate.setTranslation("it", i18n_it, true);
    } else if (value == "fr") {
      this.translate.setTranslation("fr", i18n_fr, true);
    } else {
      this.translate.setTranslation("en", i18n_en, true);
    }

    this.translate.use(GlobalService.getSelectedLanguage());

    locale(GlobalService.getSelectedLanguage());

  }

  onOpeniFrame(): void {

    
    this.iFrameURL = this.sanitizer.bypassSecurityTrustResourceUrl(environment.apiMyNamirialUrl);
    if (!this.mynamirialhiddenecheck)  {
      this.displayiFrame=true;   
    }  

    window.addEventListener("message", (e) => {


      if (e.origin !== environment.apiMyNamirialUrl) {
        return
      }

      if (e.data == "logout") {
        return
      }
            
      
      this.authenticationService.setMyNamirialToken(e.data);

      this.authenticationService.mynamiriallogin(e.data)
        .then((res: LoginResult) => {
          this.authenticationService.setCurrentToken(res.Token);          
          this.authenticationService.loggedIn.next(true);
          this.router.navigate(['/'], { queryParams: { buyLicence: this.buyLicence } });
        })
        .catch((err) => {

          this.displayiFrame = false;
          this.mynamirialhiddenecheck=false;
          this.reloadComponent();
          this.authenticationService.loggedIn.next(false);
          //this.router.navigate(['/login']);                          
          if (err.message == 'Invalid Token') {
            DialogService.Error(err.message);
          } else {
            DialogService.Confirm(this.translate.instant('DIALOGS.MYNAMIRIAL_BIND_REQUEST'), () => {              
              this.openDialog();
            }, true)
          };
        });

      // Dal token ricavo le credenziali ed il token di fatture plus


      //window.location.reload();      
      //this.displayiFrame=false;
      //this.router.navigate(['/login']);      

    });



  }

  openDialog(): void {


    const dialogRef = this.dialog.open(MynamirialbindingComponent, {
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'loginOK') {
        this.authenticationService.mynamiriallogin(this.authenticationService.getMyNamirialToken())
          .then((res: LoginResult) => {            
            this.authenticationService.setCurrentToken(res.Token);            
            this.authenticationService.loggedIn.next(true);
            this.router.navigate(['/'], { queryParams: { buyLicence: this.buyLicence } });
          })
      } else if (result == 'Register') {
        this.router.navigate(['/register'], { queryParams: { nma: this.authenticationService.getNamirialAccount(), buyLicence: this.buyLicence } });
      }
    });
  }



  onCloseiFrame(): void {

    //const element: HTMLIFrameElement = document.getElementById('ifmynamirial') as HTMLIFrameElement;
    //const childWindow = element?  element.contentWindow: null;    

    //if (childWindow !== null) {
    //  childWindow.postMessage("closeiframecontainer", "*");
    //}
    this.displayiFrame = false;



  }
  
}
